module.exports = __webpack_public_path__ + "static/media/partitions_allImpact_10y_n.31c44f31.csv";